import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { UserSearchFilter } from '../../../models/userSearchFilter';

@Component({
  selector: 'app-user-search-box',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule],
  templateUrl: './user-search-box.component.html',
  styleUrl: './user-search-box.component.scss'
})
export class UserSearchBoxComponent {
  @Input() isSearchVisible: boolean = false;
  @Output() userSearchFilter = new EventEmitter<UserSearchFilter>();

  searchForm = {
    userName: undefined,
    fullName: undefined,
    email: undefined
  };

  onSearch(): void {
    this.userSearchFilter.emit({ ...this.searchForm });
  }

  clearSearch(): void {
    this.searchForm = {
      userName: undefined,
      fullName: undefined,
      email: undefined
    };
    this.userSearchFilter.emit({ ...this.searchForm });
  }

}
